module.exports = __webpack_public_path__ + "static/img/book6.b5e2739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book6.jpg
// module id = osM/
// module chunks = 1